<div class="modal fade" id="askTagsModal" tabindex="-1">
	<div class="modal-dialog">
		<div class="modal-content">
			<div class="modal-header">
				<h5 class="modal-title">Czy usunąć ten tag?</h5>
			</div>
			<div class="modal-footer">
				<button type="button" class="btn btn-secondary" data-bs-dismiss="modal" (click)="askNo()">Nie</button>
				<button type="button" class="btn btn-primary" (click)="askYes()">Tak</button>
			</div>
		</div>
	</div>
</div>

<div class="card">
	<div class="card-body">
		<h5 class="card-title">Tagi</h5>
		<div class="card-text">
			<ul class="list-group">
				<li class="list-group-item d-flex justify-content-between align-items-center" *ngFor="let item of tags">
					{{ item.tag }}
					<span class="badge rounded-pill bg-danger" (click)="removeAsk(item.tag)">X</span>
				</li>
			</ul>
			<hr />
			<form (submit)="submit()">
				<ng-select
					name="newTag"
					[(ngModel)]="newTag"
					[items]="tagsList"
					placeholder="Wybierz tag"
					bindLabel="name"
					bindValue="tag"
				>
				</ng-select>
				<div class="d-grid">
					<button class="btn btn-outline-primary" type="submit">+ Dodaj tag</button>
				</div>
			</form>
		</div>
	</div>
</div>
